import materializePagination from 'helpers/materializePagination'

export default {
  name: 'common-pagination',

  props: {
    /**
     * @desc Data length
     */
    length: {
      type: Number
    },

    /**
     * @desc Receives the parent current page
     */
    currentPage: {
      type: Number,
      default: 1
    },

    /**
     * @desc Set the limit of items by parent
     */
    limitInList: {
      type: Number,
      default: 5
    },
    /**
     * @desc define a custom URL parameter
     */
    urlParameter: {
      type: String,
      default: ''
    }
  },

  data() {
    /**
     * @desc Component data
     *
     * @var actualPage Actual Page given by parent
     * @var elementId Generate random class to pagination element
     */
    return {
      actualPage: this.currentPage,
      elementId: 'pagination-' + Math.floor(Math.random() * 9999)
    }
  },

  computed: {
    /**
     * @desc Validation to show previous page link
     */
    showPrevLink() {
      return this.actualPage > 1
    },

    /**
     * @desc Validation to show next page link
     */
    showNextLink() {
      return this.actualPage < this.length
    }
  },

  watch: {
    /**
     * @desc Updates pagination when length is changed
     */
    length: function (value) {
      this.buildPagination()
    }
  },

  mounted() {
    materializePagination()
    this.buildPagination()
  },

  methods: {
    /**
     * @desc Emits an event to parent perform a page number update
     *
     * @param {number} number
     */
    updatePageNumber(number) {
      this.$emit('updatePageNumber', number)
    },

    /**
     * @desc Build the initial pagination
     */
    buildPagination() {
      const that = this

      if (that.length < 1) {
        return
      }

      /**
       * Remove old paginations
       */
      // $('#' + that.elementId + ' > .pagination').remove()
      $(this.$el).find('.pagination').remove()

      /**
       * Create new pagination
       */
      $(this.$el).materializePagination({
        // align: 'center',
        lastPage: that.length,
        firstPage: 1,
        urlParameter: that.urlParameter,
        useUrlParameter: that.urlParameter !== '',
        onClickCallback: function (page) {
          that.updatePageNumber(page)
        }
      }).show()
    }
  }
}
